/**
 * @file StatusRenderer.tsx
 * @description Custom cell renderer for displaying status icons in AG Grid.
 * Renders different icons based on the status value ("new", "generating", "done").
 */

import React, { useMemo } from "react";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

const StatusRenderer: React.FC<{ value: string }> = ({ value }) => {
  const icon = useMemo(() => {
    switch (value) {
      case "pending":
        return (
          <AddCircleOutlineIcon
            className="text-gray-line"
            titleAccess="Da generare"
          />
        );
      case "generating":
        return (
          <AutorenewIcon
            className="text-accent animate-spin"
            titleAccess="Generazione in corso"
          />
        );
      case "completed":
        return (
          <CheckCircleOutlineIcon
            className="text-accent"
            titleAccess="Generazione completata"
          />
        );
      default:
        return null;
    }
  }, [value]);

  return (
    <div
      className="flex items-center justify-center"
      style={{
        height:
          "min(var(--ag-internal-calculated-line-height), var(--ag-internal-padded-row-height))",
      }}
    >
      {icon}
    </div>
  );
};

export default StatusRenderer;
